import { ExperimentId } from 'core/type/ExperimentId';
import { getBootstrapConfig } from 'core/window/windowService';
import * as availabilitySelectors from 'component/page/detail/store/availability.selectors';
import * as availabilityDEPRECATEDSelectors from 'component/page/detail/store/availabilityDEPRECATED.selectors';

type AvailabilitySelectorModuleType = typeof availabilitySelectors;

const availabilitySelectorModule: AvailabilitySelectorModuleType = (() => {
    const config = getBootstrapConfig();
    const isNewImplementationEnabled = config.experiments[ExperimentId.ACT_4944];

    if (!isNewImplementationEnabled) {
        return availabilityDEPRECATEDSelectors as unknown as AvailabilitySelectorModuleType;
    }
    return availabilitySelectors;
})();

export const {
    selectActivityDetail,
    selectActivityFromDetail,
    selectActivityContentLocale,
    selectAvailabilityState,
    selectAvailabilityIsLoading,
    selectAvailabilityIsSearchCriteriaUpdated,
    selectAvailabilitySearchCriteriaStatus,
    selectSelectedBookingRequirement,
    selectTotalPax,
    selectOfferSelected,
    selectOfferOptionTokenFromOfferSelected,
    selectOfferGroupIdFromSelectedOfferGroup,
    selectActivityIdFromSelectedOffer,
    selectSelectedSpecifications,
    selectPossibleOfferOptions,
    selectBasedCalendarOfferIds,
    selectUnavailableDatesFromAvailabilityResponse,
    selectFinalOfferOption,
    selectFinalOfferId,
    selectFinalOfferOptionId,
    selectAllOfferOptions,
    selectPassengerOption,
    selectAvailabilityQuantitySelectedOffer,
    selectOfferLevelSelectedDate,
    selectOfferLevelPaxRequirements,
    selectAvailabilitySelectedDate,
    selectIsOfferDateChipSelected,
    selectIsShowDateChipNotification,
    selectIsShowOptionSpecNotification,
    selectIsShowDateNotAvailableNotification,
    selectIsCartEligibleSelected,
    selectPaxInfo,
    selectAvailabilitySelectedOfferDetail,
    selectCheapestAvailableOffer,
    selectPageContentStatus,
    selectInclusionExclusionFromDetail,
    selectTotalMaxPax,
} = availabilitySelectorModule;

export default availabilitySelectorModule;
